import { createStyles, Theme } from '@material-ui/core';

export default ({
  palette: {
    common: { white },
  },
  custom: {
    palette: { colorAccentAloe },
  },
}: Theme) =>
  createStyles({
    badge: {
      top: '85%',
      right: 6,
      minWidth: 0,
      width: 10,
      height: 10,
      border: `1px solid ${white}`,
      background: colorAccentAloe,
    },
  });
